// extracted by mini-css-extract-plugin
module.exports = {"bundleDetailsFooter":"az_lWc","summary":"az_mWc","label":"az_nWc","totalPrice":"az_oWc"};